import { render, staticRenderFns } from "./VacancyCandidatesKanban.vue?vue&type=template&id=f0b921a2&scoped=true&"
import script from "./VacancyCandidatesKanban.vue?vue&type=script&lang=js&"
export * from "./VacancyCandidatesKanban.vue?vue&type=script&lang=js&"
import style0 from "./VacancyCandidatesKanban.vue?vue&type=style&index=0&id=f0b921a2&lang=scss&scoped=true&"
import style1 from "./VacancyCandidatesKanban.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./VacancyCandidatesKanban.vue?vue&type=style&index=2&id=f0b921a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b921a2",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCandidatesKanban.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCandidatesKanban.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VCol,VRow})
